<template>
    <div :style="theme">
        <layout :settingsConfig="settingsConfig ?? []" v-on:submitWithoutAuth="submitClientInfos" :fo_config="fo_config" :account_title="fo_config['redirected'] != 1 ? 'Mon compte' : 'MES RENDEZ-VOUS'">
            <section class="section">
                <div class="box">
                    <div class="columns">
                        <div class="column is-one-third">
                            <!-- <img v-if="getImage()" :src="getImage()" alt=""> -->
                            <div>
                                <div class="rdv-info-header">
                                    <div class="is-size-4 is-size-5-mobile has-font-weight-bold">{{getSelectedPrestationsString()}}</div>
                                    <div v-if="agenda" class="is-size-5 is-size-6-mobile pb-1">{{agenda.internet_name || agenda.name}}</div>
                                </div>
                                <div class="rdv-info-body">
                                    <p class="has-text-centered" v-if="start_date">

                                    </p>
                                    <p v-if="config.display_duration">
                                        <span class="icon is-large">
                                            <i class="fa fa-clock fa-lg"></i>
                                        </span>
                                        {{getDuration}}
                                    </p>
                                    <p v-if="config.display_price">
                                        <span class="icon is-large">
                                            <i class="fa fa-euro-sign fa-lg"></i>
                                        </span>
                                        {{getPrice}}
                                    </p>
                                    <div class="columns mb-0 is-mobile"  v-if="location">
                                        <div class="column is-narrow is-flex is-flex-direction-column is-justify-content-center pr-0 pb-0">
                                            <span class="icon is-large pb-0"><i class="fa fa-map-marker-alt fa-lg"></i></span>
                                        </div>
                                        <div class="column px-0 pb-0">
                                            <p>{{location.name}}</p>
                                            <p>{{renderLocationAddress(location)}}</p>
                                        </div>
                                    </div>

                                    <p v-if="start_date">
                                        <span class="icon is-large">
                                            <i class="fa fa-clock fa-lg"></i>
                                        </span>
                                        {{formatDateMoment(start_date, 'DD/MM/YYYY à HH:mm')}}
                                    </p>

                                </div>
                            </div>
                        </div>

                        <div class="column is-two-thirds">
                             <div class="columns is-mobile is-justify-content-center" id="times-slots-container">
                                <div class="data-loader" v-if="is_loading">
                                    <i class="fas fa-circle-notch fa-spin"></i>
                                </div>
                                <div
                                 v-if="!no_free_times"
                                :class="
                                    can_scroll_right ?
                                    'column is-narrow icon calendar-nav-button'
                                    :
                                    'column is-narrow icon calendar-nav-button disabled'"
                                tabindex="0" role="button"
                                @keyup.enter="scrollRight"
                                @keyup.space="scrollRight"
                                @click="scrollRight">
                                    <i class="fas fa-angle-left"></i>
                                </div>
                                <div
                                    @scroll="onFreesTimeScroll"
                                    class="column is-10 is-flex is-flex-direction-column"
                                    id="free-times-container">
                                    <div class="columns is-mobile is-variable is-1-mobile">
                                        <div class="column day-free-time-wrapper is-one-quarter-tablet is-one-fifth-desktop is-one-third-mobile is-flex is-flex-direction-column is-justify-content-center is-align-items-center" v-for="(day, name, iDay) in days" :key="iDay">
                                            <div class="has-text-centered pb-4">
                                                {{day.date_string}}
                                            </div>
                                            <div class="day-free-times-container is-flex-grow-1">
                                                <div v-for="(free_time, i_f_t) in day.free_times" :key="i_f_t" v-bind:ref="'free_time_'+iDay+''+i_f_t" tabindex="0" role="button" @keyup.enter="setStartDate($event, free_time)" @keyup.space="setStartDate($event, free_time)" class="free_time_button" @click="setStartDate($event, free_time)">
                                                    {{formatDateMoment(free_time.start, 'HH:mm')}}
                                                </div>
                                                <div v-for="(slot, index) in getEmptySlotsNumber(day)" :key="index" class="free-time-placeholder">
                                                    <div></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="no-free-times-placeholder" v-if="no_free_times">
                                        <div class="has-text-danger has-text-centered">
                                            Aucun créneau disponible.
                                        </div>
                                    </div>
                                </div>

                                <div tabindex="0" role="button" @keyup.enter="switchNext" @keyup.space="switchNext" class="column is-narrow icon calendar-nav-button" @click="switchNext" v-if="!no_free_times">
                                    <i class="fas fa-angle-right"></i>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <confirmation-popup
                v-if="show_popup"
                v-on:closeModal="hideModal"
                :agenda="agenda"
                :config="config"
                :rdv_data="rdv_data"
                :attendees="getAttendeesFromRdv(rdv_data)"
                :client_infos="client_infos"
                :withAuth="withAuth()"
                :autoSelectNext="withAutoSelectNext()"
                :location="location"
                :duration="getDuration"
                :price="getPrice"
                :prestations="prestations"
                :group_size="group_size"
                :prestations_ids="getSelectedPrestationsIds()"
                :start_date="formatDateMoment(start_date, 'DD/MM/YYYY à HH:mm')"
                :fo_config="fo_config"
            ></confirmation-popup>
        </layout>
    </div>
</template>

<script>
import { Inertia } from "@inertiajs/inertia";
import axios from 'axios'
import confirmationPopup from './ConfirmationPopup.vue'
import moment from 'moment'
import Layout from '../Layout.vue'
import {toast} from 'bulma-toast'
// import ConfirmationPopUp from "../SharedComponents/ConfirmationPopUp.vue";

export default {
    name: 'ConfirmationRdv',
    props: ['agendas', 'config', 'locations', 'prestations', 'group_sizes', 'settingsConfig', 'fo_config', 'price', 'rdv'],
    components: {Layout, confirmationPopup, ConfirmationPopUp},
    computed: {
        allow_subgroup () {
            this.prestations[0]?.allow_subgroup
        },
        availableAgendas () {
            if (!this.location_id) return this.agendas
            return this.agendas.filter(agenda => agenda.location_id == this.location_id)
        },
        can_scroll_right () {
            let container = document.querySelector('#free-times-container')
            return container.scrollLeft === 0
        },
        getPrice () {
            if (
                !this.config.display_price
                ||
                this.prestations.find(prestation => !prestation.display_price)
            ) return 'Non communiqué'
            return this.price;
        },
        getDuration () {
            if (
                !this.config.display_duration
                ||
                this.prestations.find(prestation => !prestation.display_duration)
            ) return 'Durée non communiquée'

            let duration = this.prestations.reduce((accumulator, prestation) => accumulator += prestation.duration, 0)
            let hours = Math.floor(duration / 60)
            let minutes = duration % 60
            if (minutes < 10 && minutes != 0) minutes = '0' + minutes
            let str = ''
            if (hours) str += hours + 'h'
            if (minutes) str += minutes + ' minutes'
            return str
        },
        is_prestation_groupe() {
            return this.prestations[0]?.is_group
        },
        max_group_size () {
            return this.prestations[0]?.max_nbr_clients
        },
        no_free_times () {
            return Object.values(this.days).every(day => day.free_times.length === 0)
        },
        user() {
            return this.$page.props.auth.user?.client?.[0]
        },
        theme(){
            return this.fo_config['theme'];
        },
        redirected(){
            return this.fo_config && (this.fo_config['redirected'] == 1);
        },
        
    },
    data () {
        return {
            agenda_id: null,
            agenda: null,
            rdv_data: null,
            client_infos: null,
            days: {},
            free_times: [],
            group_size: null,
            is_loading: false,
            location: null,
            show_popup: false,
            time_slot_clicked: false,
            start_date: null
        }
    },
    methods: {
        getAttendeesFromRdv(rdv){
            if(rdv && rdv.participants){
                for (const participant of rdv.participants) {
                    if (participant.client_id == this.user.client_id) {
                        let attendees = JSON.parse(participant.attendees ?? '[]');
                        return attendees;
                    }
                }
            }
            return null;
        },
        withAuth(){
            return !(this.settingsConfig && this.settingsConfig["BOOK_WITHOUT_SUBSCRIPTION"] && this.settingsConfig["BOOK_WITHOUT_SUBSCRIPTION"] == 1);
        },
        withAutoSelectNext(){
            return (this.settingsConfig && this.settingsConfig["AUTO_BOOKING"] && this.settingsConfig["AUTO_BOOKING"] == 1);
        },
        formatDate(d) {
            let date = new Date(d)
            let days = ['Dim.', 'Lun.', 'Mar.', 'Mer.', 'Jeu.', 'Ven.', 'Sam.']
            let months = ['jan.', 'fév.', 'mars.', 'avr.', 'mai.','juin.', 'juil.', 'aout.', 'sept.', 'oct.', 'nov.', 'déc.']
            return days[date.getUTCDay()] + ' ' + date.getUTCDate() + ' ' + months[date.getUTCMonth()]
        },
        formatDateMoment(date, format) {
            return moment(date).locale('fr').format(format)
        },
        getEmptySlotsNumber(day) {
            let slot_number = []
            for (let day in this.days) {
                slot_number.push(this.days[day]?.free_times?.length || 0)
            }
            const max_number = Math.max(...slot_number)
            return max_number - day.free_times.length
        },
        getSelectedPrestationsString() {
            return this.prestations.map(prestation => prestation.fo_name || prestation.bo_name).join(', ')
        },
        getSelectedPrestationsIds(){
            return this.prestations.map(prestation => prestation.prestation_id);
        },
        getImage() {
            let prestation_with_image = this.prestations.find(prestation => prestation.image)
            if (!prestation_with_image) return false
            return prestation_with_image.image
        },
        getFreeTimes(start_date = null) {
            let prestation_id = this.prestations.map(prestation => prestation.prestation_id).join('/')
            let query = {}
            if (parseInt(this.location_id)) query.location = this.location_id
            if (parseInt(this.agenda_id)) query.agenda = this.agenda_id
            if (this.prestations.find(prestation => prestation.is_group)) {
                query.group_size = this.group_size
            }
            if (start_date) query.from = start_date
            let params = new URLSearchParams(query)

            this.is_loading = true
            let url = `/rdv/slots/with-prestations/${prestation_id}?${params}`
            // Bornage si existe dans le cas de la redirection
            let redirected_params = this.get_redirected_params();
            console.log('redirected_params',redirected_params);
            
            if(redirected_params && redirected_params.min_date && redirected_params.max_date){
                url = url+`&min_date=${redirected_params.min_date}&max_date=${redirected_params.max_date}`;
            }
            return axios.get(url).then(response => {
                let data = response.data
                this.setDays(data)
                this.is_loading = false
            })
        },
        get_redirected_params(){
            if(!this.redirected){
                return null;
            }

            let all_params = new URLSearchParams(window.location.search);
            let params = all_params.get('all_params_redirect');
            if(params != null){
                return JSON.parse(atob(params));
            }
            return null;
        },
        hideModal() {
            this.show_popup = false
            this.start_date = null
            let active_button = document.querySelector('.free_time_button.is-active')
            if (active_button) active_button.classList.remove(('is-active'))
            this.time_slot_clicked = false;
        },
        parseUrl() {
            const urlParams = new URLSearchParams(window.location.search);
            if (urlParams.get('agenda_id') && parseInt(urlParams.get('agenda_id'))) {
                this.agenda_id = urlParams.get('agenda_id')
                this.agenda = this.agendas.find(agenda => agenda.agenda_id == this.agenda_id)
                if (!this.agenda) return this.$inertia.get('/ressources')
            }
            if (urlParams.get('location_id') && parseInt(urlParams.get('location_id'))) {
                this.location_id = urlParams.get('location_id')
                this.location = this.locations.find(location => location.location_id == this.location_id)
                if (!this.location) return this.$inertia.get('/ressources')
            }
            if (this.prestations.find(prestation => prestation.is_group)) {
                if (this.prestations.length > 1) {
                    toast({
                        message: 'Impossible de combiner les prestations de groupe avec d\'autre prestations.',
                        type: 'is-danger',
                        duration: 4000,
                        pauseOnHover: true
                    })
                    return this.$inertia.get('ressources')
                }
                let prestation = this.prestations[0]
                if (!prestation.allow_subgroup) this.group_size = 1
                else this.group_size = parseInt(urlParams.get('group_size')) || 1
            }
        },
        isEndOfContainer() {
            let container = document.querySelector('#free-times-container')
            return container.scrollLeft >= container.scrollWidth - container.clientWidth - 1
        },
        isFirstDate() {
            let first_date = Object.keys(this.days)[0]
            return !moment().isAfter(first_date, 'day')
        },
        renderLocationAddress(location) {
            if (!location.address) return ''
            let localisation_regex = /((\-?|\+?)?\d+(\.\d+)?),\s*((\-?|\+?)?\d+(\.\d+)?)/
            return location.address.split(' ').filter(elt => !elt.match(localisation_regex)).join(' ')
        },
        scrollLeft() {
            let container = document.querySelector('#free-times-container')
            let scroll_level = container.offsetWidth
            container.scrollLeft += scroll_level
            // if (container.scrollLeft > 0) this.can_scroll_right = true
        },
        scrollRight() {
            let container = document.querySelector('#free-times-container')
            let scroll_level = container.offsetWidth
            container.scrollLeft -= scroll_level

            // if (container.scrollLeft === 0) this.can_scroll_right = false

        },
        setDays(data) {
            data.sort((a,b) => (new Date(a.start)).getTime() - (new Date(b.start)).getTime());
            let slotsPerDays = new Map();
            for(let slot of data){
                let d = slot.start.split(' ')[0];
                if(slotsPerDays.has(d)){
                    slotsPerDays.get(d).push(slot)
                }else{
                    slotsPerDays.set(d, [slot]);
                }
            }
            for(let [day,slots] of slotsPerDays.entries()){
                this.days[day] = {
                    date: day,
                    date_string: this.formatDate(day),
                    free_times: slots,
                };
            }
        },
        setStartDate(e, free_time) {
            if(moment(free_time.start).isValid()){
                this.time_slot_clicked = true;
                let active_button = document.querySelector('.free_time_button.is-active')
                if (active_button) active_button.classList.remove(('is-active'))
                e.target.classList.add('is-active')
                this.start_date = free_time.start

                this.agenda_id = free_time.agenda_id
                this.agenda = this.agendas.find(agenda => agenda.agenda_id == free_time.agenda_id)
                this.location = this.locations.find(location => location.location_id == this.agenda.location_id)

                if(!this.rdv_data){
                    this.rdv_data = {}
                }else{
                    this.rdv_data.current_client = this.user;
                }
                this.rdv_data.day  = moment(this.start_date).format('YYYY-MM-DD');
                this.rdv_data.heure  = moment(this.start_date).format('HH:mm');
                this.rdv_data.start_date = this.start_date;
                let duration = this.prestations.reduce((accumulator, prestation) => accumulator += prestation.duration, 0)
                this.rdv_data.end_date = moment(this.start_date).add(duration, 'minutes').format('YYYY-MM-DD HH:mm');
                this.rdv_data.group_size  = this.group_size;
                this.rdv_data.idAgenda  = this.agenda_id;
                this.rdv_data.idPrestation  = this.prestations.map(prestation => prestation.prestation_id).toString();
                this.rdv_data.location_id  = this.location_id;

                // console.log(this.rdv_data);
                

                if (this.user) this.show_popup = true
                else this.toggleAuthModal()
            }else{
                toast({
                    message: "Date invalide: Il y a un problème avec le créneau choisi",
                    type: 'is-danger',
                    duration: 5000,
                    pauseOnHover: true
                })
            }
        },
        switchNext() {
            let container = document.querySelector('#free-times-container')
            if (container.scrollLeft + container.offsetWidth >  container.scrollWidth - container.clientWidth){
                this.loadNext().then(()=>this.$nextTick()).then(()=>this.scrollLeft())
            }else{
                this.scrollLeft()
            }

        },
        loadNext(){
            let last_date = Object.keys(this.days).pop()
            let start_date = moment(last_date).add(1, 'days').format('YYYY-MM-DD')
            return this.getFreeTimes(start_date)
        },
        onFreesTimeScroll(){
            if(this.isEndOfContainer()){
                this.loadNext();
            }
        },
        toggleAuthModal() {
            let modal = document.querySelector('#auth-modal')
            modal.classList.toggle('is-active')
        },
        submitClientInfos(data){
            // console.log("submitClientInfos");
            
            this.client_infos = data;
            this.show_popup = true;
        },

    },
    mounted() {
        this.parseUrl();

        // Initialisation du token et authentification de l'utilisateur
        if(this.fo_config['redirected'] == 1){
            let token = (new URLSearchParams(location.search)).get('token');
            if(token){
                axios.post('/redirect/auth/login', {
                    token: token
                })
                .then(response => {
                    this.form_error = null;
                    let user = response.data.client;
                    this.$emit('userLogin', user);
                    Inertia.reload({ only: ["auth.user"] });
                })
                .catch(err => {
                    this.form_error = err?.response?.data?.message ?? 'Une erreur est survenue'
                })   
            }
        }

        if (this.location_id) {
            this.location = this.locations.find(location => location.location_id == this.location_id)
            if (!this.location) return this.$inertia.get('/ressources')
        } else if (this.agenda_id) {
            this.agenda = this.agendas.find(agenda => agenda.agenda_id == this.agenda_id)
            this.location = this.locations.find(location => location.location_id == this.agenda.location_id)
            if (!this.agenda || !this.location) return this.$inertia.get('/ressources')
        }
        this.getFreeTimes().then(()=>{
            // Si La réservation automatique est activée, sélectionner le premier créneau
            if(this.settingsConfig["AUTO_BOOKING"] == 1 ?? null){
                let keys = Object.keys(this.days);
                if(keys.length > 0){
                    this.$refs.free_time_00.click();
                }
            }
        });
        // En cas de modification initialiser le rdv
        this.rdv_data = this.rdv;
        // if(this.rdv_data.rdv_id){
        //     this.rdv_data.participants = this.getAttendeesFromRdv(this.rdv_data);
        // }
        // console.log("confirmationrdv rdv",this.rdv,this.rdv_data);
        
    },
    watch: {
        user(value) {
            if (value && this.rdv_data && this.time_slot_clicked) this.show_popup = true;
        }
    }
}
</script>

<style scoped>
    .rdv-info-header {
        background-color: var(--card-header-bg-color);
        color: var(--card-header-text-color);
        border-radius: 20px;
        text-align: center;
        width: 60%;
        margin: auto;
        position: relative;
        top: 31px;
        padding: 2px 5px;
    }
    .rdv-info-body {
        background-color: var(--card-content-bg-color);
        padding-bottom: 15px;
        padding-top: 40px;
        border-radius: 20px;
    }
    #free-times-container {
        overflow-y: hidden;
        max-width: 740px;
    }
    .free_time_button {
        user-select: none;
        cursor: pointer;
        width: 100%;
        height: 42px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: var(--btn-time-slot-bg-color);
        color: var(--btn-time-slot-text-color);
        font-weight: bold;
        border-radius: 3px;
        margin-bottom: 7px;
    }
    .day-free-times-container {
        width: 100%;
    }
    .free_time_button.is-active, .free_time_button.is-active:hover {
        color: var(--main-theme-color);
        background-color: #fff;
        border: 1px solid var(--main-theme-color);
    }
    .free_time_button:hover {
        background-color: var(--btn-time-slot-bg-color-hover);
        color: var(--btn-time-slot-text-color-hover);
    }
    .free-time-placeholder {
        width: 100%;
        height: 42px;
        margin-bottom: 7px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .free-time-placeholder > div{
        margin: 0 auto;
        width: 10px;
        height: 4px;
        background-color: #cdcdcd;
    }
    .calendar-nav-button {
        cursor: pointer;
        font-size: larger;
    }
    .calendar-nav-button.disabled {
        opacity: .4;
        cursor: not-allowed;
    }
    #times-slots-container {
        position: relative;
    }
    .data-loader {
        position: absolute;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #fff9;
    }
    .data-loader > i {
        height: 20px;
    }
    .no-free-times-placeholder {
        min-height: 200px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    @media (max-width: 769px) {
        .free_time_button, .free-time-placeholder {
            /* width: 64px; */
            height: 34px;
        }
    }
</style>
